<template lang="html">
   <div class="test-form">
      <Modal 
         :show="show" 
         :loading="loading" 
         :icon="FuelStation.forms.add_fuel_station.icon" 
         :title="FuelStation.forms.add_fuel_station.title" 
         :subtitle="FuelStation.forms.add_fuel_station.subtitle" 
         @close="$store.commit('show',false)"
         @submit="addStation({ref: $refs[FuelStation.forms.add_fuel_station.name]})"
      >
         <template slot="form">
            <Form 
               classBinding="row" 
               :ref="FuelStation.forms.add_fuel_station.name" 
               :forms="FuelStation.forms.add_fuel_station.forms" 
               :form_data="FuelStation.forms.add_fuel_station.data"
            />
         </template>
      </Modal>

      <Modal 
         :show="showUpload" 
         :loading="loading" 
         :icon="FuelStation.forms.upload_fuel_station.icon" 
         :title="FuelStation.forms.upload_fuel_station.title" 
         :subtitle="FuelStation.forms.upload_fuel_station.subtitle" 
         button="upload"
         @close="$store.commit('showUpload',false)"
         @submit="uploadStations({ref: $refs[FuelStation.forms.upload_fuel_station.name]})"
      >
         <template slot="form">
            <Form 
               classBinding="row" 
               :ref="FuelStation.forms.upload_fuel_station.name" 
               :forms="FuelStation.forms.upload_fuel_station.forms" 
               :form_data="FuelStation.forms.upload_fuel_station.data"
            />
         </template>
      </Modal>

      <Table 
         :icon="FuelStation.tables.stations.icon" 
         :table_fields="FuelStation.tables.stations.table_fields" 
         :table_data="stations" 
         :title="FuelStation.tables.stations.title" 
         :search_fields="FuelStation.tables.stations.search_fields"
         :row_data="FuelStation.tables.stations.row_data"
         @on-action="handleActions"
      />
   </div>
</template>

<script>
import station from "../rsc/stores/configs/fuelStations.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('station')
   },
   created(){
      EventBus.$emit('loader:show',true)
      utils.registerModule('station',station,this.$store)

      setTimeout(() => {
         EventBus.$emit('actions:register',{
            title: 'Fuel Station Actions',
            actions: [
               {
                  title: 'Upload Fuel Stations',
                  icon: 'fa-upload',
                  event: 'action:upload_fuel_station',
               },
               {
                  title: 'Add Fuel Station',
                  icon: 'fa-gas-pump',
                  event: 'action:add_fuel_station',
               },
            ]
         })
      },800);

      EventBus.$on("action:add_fuel_station", payload => {
         this.$store.commit('show', true)
      });
      EventBus.$on("action:upload_fuel_station", payload => {
         this.$store.commit('showUpload', true)
      });
   },
   components:{
      Modal: () => import("@/libs/clarks/components/modal"),
      Form: () => import("@/libs/clarks/components/form"),
      Table: () => import("@/libs/clarks/components/table/table"),
   },
   computed: {
      ...mapGetters([
         'FuelStation',
         'stations',
         'show',
         'loading',
         'showUpload',
      ])
   },
   methods: {
      ...mapActions([
         'addStation',
         'fetchStations',
         'fetchFormData',
         'uploadStations',
      ]),
      handleActions(){

      }
   },
   async mounted(){
      utils.registerModule('station',station,this.$store)
      await this.fetchFormData()
      await this.fetchStations()
   }
}
</script>

<style lang="scss">
   .test-form{
      
   }
</style>